export default function Loading() {
  return <div className="lds-dual-ring my-8 animated fadeIn"></div>
}
